import { getDeviceList } from "../../../store/slice/health-monitor/device-list";
import store from "../../../store/store";

export const loadDeviceList = async () => {
  return await store.dispatch(
    getDeviceList({
      page: store.getState().deviceList.currentPage,
      size: store.getState().deviceList.selectedRowsPerPage,
      search: store.getState().deviceList.searchInput || "",
      warning: store.getState().deviceList.activeCheckbox,
      status: store.getState().deviceList.activeSearchButton,
      searchColumn: store.getState().deviceList.columnToSearchBy,
      sortColumn: store.getState().deviceList.sortColumn,
      isDescending: store.getState().deviceList.isDesc,
    })
  );
};
